import { ConfigService } from '@services/webFeeder/config.service';
import { Injectable } from '@angular/core';
import { IEmailLoggable } from '@services/strategy-pattern-login/iEmail-loggable';
import { HttpService } from '@services/http-service';
import { EmailDeposit } from '@model/email-deposit-model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IEmailFacadeService implements IEmailLoggable {

  constructor(
    private _httpService: HttpService,
    private _configService: ConfigService,
  ) { }

  sendEmail(isRedemption: boolean, depositParams: EmailDeposit) {
    let params;
    if (isRedemption) {
      params = {
        'id': 'RedemptionEmail',
        'login': depositParams.login,
        'body': [
          { 'key': 'login', 'value': depositParams.login },
          { 'key': 'bank', 'value': depositParams.bank },
          { 'key': 'agency', 'value': depositParams.agency },
          { 'key': 'account', 'value': depositParams.account },
          { 'key': 'source', 'value': depositParams.source },
          { 'key': 'favored', 'value': depositParams.favored },
          { 'key': 'value', 'value': depositParams.value },
          { 'key': 'described_value', 'value': depositParams.described_value },
          { 'key': 'comments', 'value': depositParams.comments },
          { 'key': 'total_withdrawal_checked', 'value': depositParams.total_withdrawal_checked }
        ]
      };
    } else {
      params = {
        'id': 'DepositEmail',
        'login': depositParams.login,
        'body': [
          { 'key': 'login', 'value': depositParams.login },
          { 'key': 'bank', 'value': depositParams.bank },
          { 'key': 'agency', 'value': depositParams.agency },
          { 'key': 'account', 'value': depositParams.account },
          { 'key': 'destination', 'value': depositParams.destination },
          { 'key': 'value', 'value': depositParams.value },
        ]
      };
    }
    return this._httpService
      .doPost(this._configService.getDepositEmailApi(), 'send_email', params, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  getEmail() {
    return this._httpService
      .doGet(this._configService.getDepositEmailApi(), 'emails')
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

}
